// Marketing pricing tiers — keep in sync with backend/config/pricingPlans.js
// (display fields only; Stripe IDs and capabilities live on the backend)

export const DEFAULT_PLAN_ID = 'basic';
export const PROFESSIONAL_TRIAL_DAYS = 14;

export const PRICING_PLANS = [
  {
    id: 'basic',
    name: 'Basic',
    description: 'Perfect for small teams getting started',
    price: 0,
    features: [
      'Up to 3 users',
      'Basic task management',
      'Email support'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'For growing teams that need more',
    price: 59,
    trialDays: PROFESSIONAL_TRIAL_DAYS,
    featured: true,
    badge: 'Most popular',
    features: [
      'Up to 20 users',
      'Advanced task management',
      'Task & checklist presets',
      'Task photo uploads',
      'Data export',
      'Priority support'
    ]
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'For large organizations with advanced needs',
    price: 199,
    features: [
      'Up to 100 users',
      'All features',
      'Dedicated support',
      'Custom integrations',
      'Advanced analytics'
    ]
  }
];

export const formatPlanPrice = (plan) => {
  if (plan.price === 0) {
    return 'Free';
  }
  return `$${plan.price}/month`;
};

export const getPlanPriceRange = () => {
  const prices = PRICING_PLANS.map((plan) => plan.price);
  return {
    lowPrice: String(Math.min(...prices)),
    highPrice: String(Math.max(...prices))
  };
};
